import { render, staticRenderFns } from "./AppRating.vue?vue&type=template&id=bda5f2da&scoped=true&"
import script from "./AppRating.vue?vue&type=script&lang=js&"
export * from "./AppRating.vue?vue&type=script&lang=js&"
import style0 from "./AppRating.vue?vue&type=style&index=0&lang=less&"
import style1 from "./AppRating.vue?vue&type=style&index=1&id=bda5f2da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda5f2da",
  null
  
)

export default component.exports